<template>
	<el-card class="guest-container">
		<template #header>
			<div class="header">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="editRole('')">新增</el-button>
				<!-- <el-button type="danger" size="small" icon="el-icon-delete" @click="">删除</el-button> -->
				<!-- <el-button type="warning" size="small" icon="el-icon-plus" @click="">导出</el-button> -->
			</div>
		</template>
		<div class="row-no-full">
			<el-card class="box-card" style="flex: 2;">
				<el-table v-loading="loading" ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%"
				 highlight-current-row @current-change="handleCurrentChange">
					<el-table-column prop="role_name" label="名称">
					</el-table-column>
					<el-table-column prop="role_description" label="描述">
					</el-table-column>
					<el-table-column prop="created_at" label="创建时间">
					</el-table-column>
					<el-table-column label="操作" width="180">
						<template #default="scope">
							<el-button type="warning" size="mini" @click="editRole(scope.row)">编辑</el-button>
							<el-button type="danger" size="mini" @click="delRole(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
			<div style="width: 2%;"></div>
			<el-card class="box-card" style="flex: 1;">
				<div style="display: flex;justify-content: space-between;" class="el-card__header clearfix">
					<div>
						<el-tooltip class="item" effect="dark" content="选择指定角色分配菜单" placement="top">
							<span class="role-span">菜单分配</span>
						</el-tooltip>
					</div>
					<div>
						<el-button :disabled="!showButton" :loading="menuLoading" icon="el-icon-check" size="mini" style="padding: 6px 9px"
						 type="primary" @click="saveMenu">保存</el-button>
					</div>

				</div>
				<el-tree ref="menu" :data="data" :props="props" v-model="menuIds" icon-class='el-icon-arrow-right' node-key="id"
				 show-checkbox @check="menuChange">
					<template #default="{ node, data }">
						<span class="custom-tree-node">
							<span>{{ node.label }}</span>
							<!-- <span>{{ data.lv }}&#12288;级分类</span> -->

						</span>
						<span>&#12288;&#12288;</span>
					</template>
				</el-tree>

			</el-card>
		</div>

	</el-card>

	<el-dialog title="添加角色" v-model="dialogFormVisible">
		<el-form :model="form" ref='form' :rules="rules">
			<el-form-item label="角色名称" :label-width="formLabelWidth">
				<el-input v-model="form.role_name" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="描述信息" :label-width="formLabelWidth">
				<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.role_description">
				</el-input>
			</el-form-item>
		</el-form>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit()">确 定</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		name: 'RoleList',
		data() {
			return {
				dialogFormVisible: false,
				loading: false,
				showButton: false,
				menuLoading: false,
				formLabelWidth: '120px',
				list: [],
				data: [],
				form: {
					role_name:'',
					role_description:'',
				},
				currentId: 0,
				menuIds: [],
				rules: {
					role_name: [{
						required: true,
						message: '用户名不能为空',
						trigger: 'blur'
					}],
					role_description: [{
						required: true,
						message: '描述信息不能为空',
						trigger: 'blur'
					}],
				},
				props: {
					label: 'title',
					children: 'all_children',

				},
			}
		},
		methods: {
			handleCurrentChange(val) {
				if (val) {
					this.$refs.menu.setCheckedKeys([]);

					this.currentId = val.id;

					// this.menuIds = [];
					// this.menuIds = val.menu_id.split(",");
					// console.log(this.menuIds);
					this.showButton = true;

					this.$nextTick(function() {
						this.menuIds.forEach((value) => {
							//1. 勾选节点的 key 或者 data 2. boolean 类型，节点是否选中 3. boolean 类型，是否设置子节点 ，默认为 false）如果全部选中setCheckedKeys
							//                         console.log(value)
							this.$refs.menu.setChecked(value, true, false);
						})
					});
					this.menuIds = val.menu_id.split(','); //点击复选框 将id 传入数组
				}
				// this.currentRow = val;
			},
			menuChange(menu) {

				this.menuIds = []; //每次点击 清空上一次复选框
				let rad = ''
				let ridsa = this.$refs.menu.getCheckedKeys().join(',') // 获取当前的选中的categories_id  逗号拼接   不包含半勾选状态父id
				// console.log(ridsa);
				let ridsb = this.$refs.menu.getCheckedNodes() // 获取当前的选中的数据{对象}  当前选中的分类信息
				// console.log(ridsb);
				ridsb.forEach(ids => { //获取选中的所有的父级id
					rad += ',' + ids.pid
				})
				rad = rad.substr(1) // 删除字符串前面的','
				// console.log(rad)
				let rids = rad + ',' + ridsa
				// console.log(rids)
				let arr = rids.split(',') //  把字符串转换成数组
				// console.log(arr)订单列表

				arr = [...new Set(arr)]; // 数组去重
				for (let i in arr) {
					if (arr[i] != 0) {
						this.menuIds.push(arr[i]); //点击复选框 将id 传入数组
					}
				}
				// this.$refs.menu.setCheckedKeys(this.menuIds)
			},

			handleNodeClick(data) {
				// console.log(data);
			},
			saveMenu() {
				let menus = this.menuIds;
				const role = {
					id: this.currentId,
					menus: menus
				}
				this.msgBoxAjax(
					'提示',
					'确定提交吗？',
					"/admin/role/role_update",
					role).then((data) => {
					// console.log(data);

					if (data.code == 1) {
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {

							this.$router.go(0);
						});
					} else {

						this.messageCommon('错误', data.msg, 'error');
					}


				});
			},
			getRole() {
				this.httpPost({
					url: '/admin/role/role_list',
					data:{
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.list = temp;
					this.loading = false;

				}).catch((err) => {
					this.loading = false;
				})
			},
			editRole(val) {
				this.form = {
					id: val.id,
					role_name: val.role_name,
					role_description: val.role_description,

				}

				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			getRoleMenu() {
				this.loading = true
				this.httpPost({
					url: '/admin/role/getRoleMenu',

				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.data = temp;
					this.loading = false;

				}).catch((err) => {
					this.loading = false;
				})
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.updateRole();
					} else {
						console.log('error submit!')
						return false;
					}
				})
			},
			updateRole() {
				let temp = this.cloneObj(this.form);
				let id = temp.id;

				if (!id) id = '';
				this.msgBoxAjax(
					'提示',
					'确定修改吗？',
					"/admin/role/add?id=" + id,
					temp).then((data) => {
					// console.log(data);

					if (data.code == 1) {
						this.dialogFormVisible = false;
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							this.getRole();
						});
					} else {

						this.messageCommon('错误', data.msg, 'error');
					}


				});
			},
			delRole(val){
				let id = val.id;
				if(id ==1) {
					this.$message.error('不能删除最高角色!');
					return false;
				}
				this.msgBoxAjax(
				  '提示',
				  '确定删除该角色吗？',
				  "/admin/role/role_del",
				  {id:id}).then((data) => {
				  // console.log(data);

				  if (data.code == 1) {
					  this.dialogFormVisible=false;
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
				      this.getRole();
				    });
				  }else{

				    this.messageCommon('错误',data.msg,'error');
				  }


				});
			}

		},
		created() {
			this.getRoleMenu();
			this.getRole();
		}
	}
</script>

<style>
	.guest-container {
		min-height: 100%;
	}

	.el-card.is-always-shadow {
		min-height: 100% !important;
	}
</style>
